import React, { useState } from 'react'
import { formatTime } from '../../utils/time.utils'

import styles from '../../styles/components/partner/payment.module.css'


function Payment({payment, refresh=()=>{}}) {
    return (
        <div className={styles.main}>
            <div>{payment?.amount} ₴</div>
            <div className={styles.iban}>
                <div>{payment?.card}</div>
                <div>{payment?.iban?.number}</div>
                <div>{payment?.iban?.INN}</div>
                <div>{payment?.iban?.number && (payment?.iban?.target || 'dafault')}</div>
            </div>
            <div>{payment?._id}</div>
            <div className={`${styles.status} ${payment?.status}`}>{payment?.status}</div>
            <div className={styles.date}>
                {formatTime(payment?.createdAt).replaceAll(',', " ")}
            </div>
        </div>
      )
}

export default Payment